import { Progress } from '@/components/ui/progress'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import { HTMLAttributes } from 'react'
export interface ProductNotificationInfoNotifiedProps {
  currentPrice: number
  notificationPrice: number
  highestPrice: number
}

export const ProductNotificationInfoNotified = ({
  className,
  currentPrice,
  notificationPrice,
  highestPrice,
  ...props
}: ProductNotificationInfoNotifiedProps & HTMLAttributes<HTMLDivElement>) => {
  const percent = (notificationPrice / currentPrice) * 100
  return (
    <div className={cn('flex flex-col gap-4', className)} {...props}>
      <div>
        <p className="text-body-02-medium">알림 가격까지</p>
        <p className="text-heading-02-bold">
          {(currentPrice - notificationPrice).toLocaleString()}원 남았어요!
        </p>
      </div>
      <div className="relative">
        <Progress value={percent} />
        <Image
          src={'/icons/상품상세_벨_미도달.svg'}
          alt={''}
          width={38}
          height={38}
          className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2"
        />
      </div>

      <div className="flex justify-between">
        <div>
          <p className="text-body-02-medium">최고가</p>
          <p className="text-xs">{highestPrice.toLocaleString()}원</p>
        </div>
        <div>
          <p className="text-body-02-medium">알림가</p>
          <p className="text-xs">{notificationPrice.toLocaleString()}원</p>
        </div>
      </div>
    </div>
  )
}
